import React, { Fragment } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { RaisedButton, Dialog } from 'material-ui';

import { changePort } from 'actions/regions/ports';
import { formValueSelector, reduxForm } from 'redux-form';

import { formName } from 'data/formNames';

import ServiceProviderFormFields from './FormFields';

const styles = {
    dialog: {
        contentStyle: { width: '843px', padding: '20px' },
    },
    textField: {
        floatingLabelStyle: {
            fontSize: '12px',
        },
    },
    btn: {
        labelStyle: { color: '#fff' },
    },
};

const EditServiceProvider = (props) => {
    const {
        open, toggle, field, serviceProvider, handleSubmit, changePort,
        change: formChange, hasRecommended, reset,
    } = props;

    const onRequestClose = () => {
        reset();
        toggle();
    };

    const onSubmit = (submit) => {
        toggle();
        changePort(submit);
    };

    return (
        <Dialog
            open={open}
            contentStyle={styles.dialog.contentStyle}
            onRequestClose={onRequestClose}
            paperClassName="dialog-service-provider"
            bodyStyle={{ overflowY: 'auto' }}
        >
            <Fragment>
                <form>
                    <div className="title">
                    Edit Service Provider: <br />
                    Marine equipment & spare parts
                    </div>

                    <ServiceProviderFormFields 
                        field={field} 
                        serviceProvider={serviceProvider} 
                        formChange={formChange} 
                        hasRecommended={hasRecommended}
                    />

                    <div className="row">
                        <div className="col-xs-12" style={{ display: 'flex', gap: '10px' }}>
                            <RaisedButton
                                label="Cancel"
                                primary
                                onClick={onRequestClose}
                            />

                            <RaisedButton
                                label="Save"
                                backgroundColor="#7FC931"
                                labelStyle={styles.btn.labelStyle}
                                onClick={handleSubmit(onSubmit)}
                            />
                        </div>
                    </div>
                </form>
            </Fragment>
        </Dialog>
    );
};

EditServiceProvider.propTypes = {};

EditServiceProvider.defaultProps = {};

const FormEditServiceProvider = reduxForm({
    form: formName.portUpdateEditServiceProvider,
    enableReinitialize: true,
})(EditServiceProvider);

const selector = formValueSelector(formName.portUpdate);
const selectorEditProvider = formValueSelector(formName.portUpdateEditServiceProvider);
export default connect(
    (state, ownProps) => ({
        initialValues: { serviceProviders: selector(state, 'serviceProviders') },
        serviceProvider: selectorEditProvider(state, ownProps.field),
    }),
    dispatch => bindActionCreators({
        changePort,
    }, dispatch),
)(FormEditServiceProvider);



// WEBPACK FOOTER //
// ./app/components/Regions/Port/ServiceProviders/EditServiceProvider.jsx